import AbstractBackground from '@/assets/images/abstract-bg.webp'
import AbstractBackground2 from '@/assets/images/Abstract-background2.webp'
import icon1 from '@/assets/images/serv-icons/0.png'
import icon2 from '@/assets/images/serv-icons/1.png'
import Translatable from '@/components/translatable_text/Translatable';

function IntroSection() {
  return (
    <section className="services-tab mt-[100px] mb-[100px] wow d-rotate">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" id="tabs">
          <div className="col-lg-6 valign">
            <div className="serv-tab-cont md-mb80">
              <div className="tab-content current" id="tabs-1">
                <div className="item">
                  <div className="img">
                    <img src={AbstractBackground} alt="image" className="rounded-lg"/>
                  </div>
                  <div className="cont sub-bg rounded-md">
                    <div className="icon-img-60 mb-40">
                      <img src={icon1} alt="icon" />
                    </div>
                    <div className="text">
                      <p>
                        <Translatable>We help organizations define clear, actionable strategies that align technology, business goals, and growth plans—turning vision into structured, achievable roadmaps.</Translatable> 
                      </p>
                    </div>
                    {/* <a href="/services/development-encryption" className="mt-30">
                      <span className="mr-15">Read More</span>
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="tab-content" id="tabs-2">
                <div className="item">
                  <div className="img">
                    <img src={AbstractBackground} alt="icon" className="rounded-lg"/>
                  </div>
                  <div className="cont sub-bg rounded-md">
                    <div className="icon-img-60 mb-40">
                      <img src={icon2} alt="icon" />
                    </div>
                    <div className="text">
                      <p>
                        <Translatable>We provide expert guidance on system architecture, technology selection, and implementation to ensure scalable, secure, and efficient technical solutions.</Translatable> 
                      </p>
                    </div>
                    {/* <a href="/light/page-services" className="mt-30">
                      <span className="mr-15">Read More</span>
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="tab-content" id="tabs-3">
                <div className="item">
                  <div className="img">
                    <img src={AbstractBackground} alt="icon" className="rounded-lg"/>
                  </div>
                  <div className="cont sub-bg rounded-md">
                    <div className="icon-img-60 mb-40">
                      <img src={icon1} alt="icon" />
                    </div>
                    <div className="text">
                    <p>
                      <Translatable>We support organizations in modernizing operations, processes, and services through digital technologies—driving efficiency, innovation, and long-term competitiveness.</Translatable>
                    </p>
                    </div>
                    {/* <a href="/light/page-services" className="mt-30">
                      <span className="mr-15">Read More</span>
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </a> */}
                  </div>
                </div>
              </div>
              <div className="tab-content" id="tabs-4">
                <div className="item">
                  <div className="img">
                    <img src={AbstractBackground2} alt="icon" className="rounded-lg"/>
                  </div>
                  <div className="cont sub-bg rounded-md">
                    <div className="icon-img-60 mb-40">
                      <img src={icon1} alt="icon" />
                    </div>
                    <div className="text">
                    <p>
                      <Translatable>
                      Through TPPM-driven consultation, GCAD has enabled organizations to
                      deliver scalable, reliable, and well-governed digital products —
                      transforming complex initiatives into successful technical outcomes.
                      </Translatable>
                    </p>
                    </div>
                    {/* <a href="/services/development-encryption" className="mt-30">
                      <span className="mr-15">Read More</span>
                      <i className="fas fa-long-arrow-alt-right"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 valign rotate-text">
            <div className="serv-tab-link tab-links full-width pt-40">
              <div className="sec-head mb-30">
                <h6 className="sub-title mb-15 main-color"><Translatable>Who we are?</Translatable></h6>
                <h2><Translatable>Your Technical Partner from Decision to Delivery.</Translatable></h2>
              </div>
              <div className="row justify-content-end">
                <div className="col-lg-11">
                  <div className="text mb-50">
                    <p>
                      <Translatable>
                      GCAD acts as an embedded technical consultant, guiding organizations
                      through structured decision-making and controlled execution. Using the
                      TPPM protocol, we ensure that every phase — strategy, design,
                      development, and deployment — moves forward with clarity and purpose.
                      </Translatable>
                    </p>
                  </div>
                  <ul className="rest">
                    <li className="item-link current mb-15" data-tab="tabs-1">
                      <h3>
                        <span className="fz-18 opacity-7 mr-15">01</span> <Translatable>Strategy Development</Translatable>
                      </h3>
                    </li>

                    <li className="item-link mb-15" data-tab="tabs-2">
                      <h3>
                        <span className="fz-18 opacity-7 mr-15">02</span> <Translatable>Technical Consulting</Translatable>
                      </h3>
                    </li>

                    <li className="item-link mb-15" data-tab="tabs-3">
                      <h3>
                        <span className="fz-18 opacity-7 mr-15">03</span> <Translatable>Digital Transformation Consulting</Translatable>
                      </h3>
                    </li>

                    <li className="hidden item-link" data-tab="tabs-4">
                      <h3>
                        <span className="fz-18 opacity-7 mr-15">04</span> <Translatable>Proven Impact</Translatable>
                      </h3>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default IntroSection;
